<ng-container *ngIf="!!formGroup" [formGroup]="formGroup">
    <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>{{placeholder}}</mat-label>
        <input matInput [formControlName]="fcName" [readonly]="readonly">
        <mat-error *ngIf="formGroup.get(fcName).hasError('required')">
            required
        </mat-error>
        <mat-hint align="end" *ngIf="!!hintMessage">{{hintMessage}}</mat-hint>
    </mat-form-field>
</ng-container>